function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#444"
}, React.createElement("path", {
  d: "M12 24a12 12 0 1 1 12-12 12.013 12.013 0 0 1-12 12zm0-22a10 10 0 1 0 10 10A10.011 10.011 0 0 0 12 2z",
  opacity: 0.4
}), React.createElement("path", {
  d: "M24 12h-2A10.011 10.011 0 0 0 12 2V0a12.013 12.013 0 0 1 12 12z",
  "data-color": "color-2"
}));

var SvgLCircle = function SvgLCircle(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLCAwKSI+PHBhdGggZD0iTTEyLDI0QTEyLDEyLDAsMSwxLDI0LDEyLDEyLjAxMywxMi4wMTMsMCwwLDEsMTIsMjRaTTEyLDJBMTAsMTAsMCwxLDAsMjIsMTIsMTAuMDExLDEwLjAxMSwwLDAsMCwxMiwyWiIgZmlsbD0iIzQ0NDQ0NCIgb3BhY2l0eT0iMC40Ij48L3BhdGg+CiAgPHBhdGggZD0iTTI0LDEySDIyQTEwLjAxMSwxMC4wMTEsMCwwLDAsMTIsMlYwQTEyLjAxMywxMi4wMTMsMCwwLDEsMjQsMTJaIiBmaWxsPSIjNDQ0NDQ0IiBkYXRhLWNvbG9yPSJjb2xvci0yIj48L3BhdGg+PC9nPjwvc3ZnPg==";
export { SvgLCircle as ReactComponent };